interface Props {
  size: number
  color: string
  sameWrapperSize?: boolean
}

export const Circle = ({ size, color, sameWrapperSize = false }: Props) => {
  return (
    <div
      className={`${!sameWrapperSize && 'h-[20px] w-[20px]'} flex items-center justify-center`}
    >
      <div
        style={{
          backgroundColor: color,
          width: size,
          height: size,
          borderRadius: '50%',
        }}
      ></div>
    </div>
  )
}
